/* use instead (new Date(...)).getTime() */
export function getTotalMilliseconds(dateStr: string) {
    return new Date(dateStr).getTime();
}
